import { render, staticRenderFns } from "./HomeBannerUser.vue?vue&type=template&id=2f2ddf6f&scoped=true"
import script from "./HomeBannerUser.vue?vue&type=script&lang=js"
export * from "./HomeBannerUser.vue?vue&type=script&lang=js"
import style0 from "./HomeBannerUser.vue?vue&type=style&index=0&id=2f2ddf6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2ddf6f",
  null
  
)

export default component.exports